'use strict';

namespace Core {

    class SelectedParkingSummary {

        parking: any;

        public quote :Core.Parking.Quote;
        public show :boolean = false;

        constructor(
            private $scope: ng.IScope
        ) {

            let stop = this.$scope.$watch('sps.parking', v => {
                if (v) {
                    this.init(v);
                    stop();
                }
            });

        }

        private init(parking :any) :void {
            this.quote = parking.Details.Quote;
            this.show = true;
        }

    }

    angular
        .module('core')
        .directive('selectedParkingSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedParkingSummary,
            controllerAs: 'sps',
            replace: true,
            bindToController: {
                parking: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedParkingSummary'
        };

    });

}
